<template>
  <div>
    <div>
      <section class="top-fixing">
        <section class="common-sub-top container">
          <section class="top-info-wrap">
            <div class="prev-wrap">
              <a @click="pageBefore()" class="prev"></a>
              <span v-if="ptntInfo.ptntNm !== ''">
                <span class="name-wrap">
                  <span class="name">{{ ptntInfo.ptntNm }}</span>
                  <!-- <strong>님</strong>의 차트 (비급여) {{ this.$route.params.selectedInfo }} -->
                </span>
              </span>
              <!-- TODO : 어디로 이동하는지 설정 필요 -->
              <span class="chart-change" @click="movePatientChartInfo()">급여차트보기</span>
            </div>
          </section>
          <section class="sub-menu">
            <a @click="tabMove('1')" class="active">환자정보</a>
            <a @click="tabMove('2')">예약정보</a>
            <a @click="tabMove('3')">상담정보</a>
            <a @click="tabMove('4')">시술정보</a>
            <a @click="tabMove('5')">시술특이사항</a>
            <a @click="tabMove('6')">수납내역</a>
          </section>
        </section>
      </section>

      <!-- 간격 조정용 -->
      <div class="space-agree"></div>
      <!-- //간격 조정용 -->

      <!-- 컨텐츠-->
      <section class="contents" id="tab1">
        <div class="tbl-wrap">
          <table class="info-tbl">
            <colgroup>
              <col width="130" />
              <col width="*" />
              <col width="130" />
              <col width="*" />
            </colgroup>
            <tr>
              <td>환자명</td>
              <td>{{ ptntInfo.ptntNm }}</td>
              <td>성별/나이</td>
              <td>
                <template v-if="ptntInfo.sex === 'M'"> 남성 </template>
                <template v-else> 여성 </template>/{{ ptntInfo.age }}
              </td>
            </tr>
            <tr>
              <td>환자번호</td>
              <td>{{ ptntInfo.ptntNo }}</td>
              <td>생년월일</td>
              <td>
                <template v-if="ptntInfo.prsnNo.length == 13">
                  {{
                    `${ptntInfo.prsnNo.substr(0, 2)}.${ptntInfo.prsnNo.substr(2, 2)}.${ptntInfo.prsnNo.substr(
                      4,
                      2
                    )}`
                  }}
                </template>
              </td>
            </tr>

            <template v-if="opdMemoViewYn === 'Y'">
              <tr>
                <td>특이사항</td>
                <td colspan="3" style="text-align: left; padding: 0.3em">
                  <template v-if="ptntInfo.opdMemo != null">
                    <div v-if="ptntInfo.opdMemo.length < 50">
                      {{ ptntInfo.opdMemo }}
                    </div>
                    <div v-else>
                      <span>{{ ptntInfo.opdMemo.substr(0, 300) }}</span>
                      <button
                        @click="clickLongText2({ title: '특이사항', msg: ptntInfo.opdMemo })"
                        class="preview"
                      >
                        더보기
                      </button>
                    </div>
                  </template>
                </td>
              </tr>
            </template>
          </table>
        </div>
        <section class="etc-info">
          <h2 class="patient-meno"><i></i>환자 메모</h2>
          <div class="info-wrap">
            {{ ptntInfo.ptntMemo }}
          </div>

          <div v-for="(item, idx) in ptntInfo.allergy" :key="idx">
            <h2 class="patient-meno"><i></i>{{ item.regNm }}</h2>
            <div class="info-wrap">{{ item.msg }}</div>
          </div>
        </section>
      </section>

      <section class="list-wrap">
        <div class="header mt20" id="tab2">
          <h2 class="other">예약정보</h2>
          <div class="select-group">
            <select title="상담/시술" v-model="selectInsrDiv" @change="changeStatus()">
              <option value="">상담/시술 전체</option>
              <option value="E20">상담</option>
              <option value="E">시술</option>
            </select>
            <select title="상태" v-model="selectStatus" @change="changeStatus()">
              <option value="">상태 전체</option>
              <option v-for="(option, index) in optionStatus" :key="index" v-bind:value="option.code">
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
        <div class="list-tbl-wrap reserve">
          <table class="list-tbl">
            <colgroup>
              <col width="10px" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="10px" />
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th>예약일시</th>
                <th>상담/시술</th>
                <th>상태</th>
                <th>예약/접수메모</th>
                <th>시행시술(특이사항)</th>
                <th>담당자</th>
                <th>진료분야</th>
                <th>부도코드</th>
                <th>부도메모</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="reserveInfo.length > 0">
                <tr v-for="(item, idx) in reserveInfo" :key="idx">
                  <template v-if="idx < reserveCnt">
                    <td></td>
                    <td>{{ item.rsrvYmd }}</td>
                    <td>{{ item.rsrvType }}</td>
                    <td v-bind:class="procColor(item.procGbNm)">
                      {{ item.procGbNm }}
                    </td>
                    <td class="preview preview-memo">
                      <div v-if="item.memo.trim().length < 100">
                        {{ item.memo }}
                      </div>

                      <div v-else>
                        <span class="the">{{ item.memo }}</span>
                        <button
                          @click="clickLongText({ title: '예약/접수메모', msg: item.memo })"
                          class="preview"
                        >
                          더보기
                        </button>
                        <!-- <input type="checkbox" name="preview" :disabled="item.memo.trim().length === 0" :id="`memo${idx}`" @click="clickLongText($event)" />
												<label :for="`memo${idx}`">더보기</label>

												<div class="openview">
													<span @click="clickLongTextClose(`memo${idx}`)"></span>
													<h2>예약/접수메모</h2>
													<div class="text">
														{{ item.memo }}
													</div>
												</div> -->
                      </div>
                    </td>
                    <!-- <td>111{{ item.procedureInfo }}</td> -->
                    <td class="preview preview-procedureInfo">
                      <div v-if="item.procedureInfo.trim().length < 100">
                        {{ item.procedureInfo }}
                      </div>
                      <div v-else>
                        <span class="the">{{ item.procedureInfo }}</span>
                        <button
                          @click="clickLongText({ title: '시행/시술', msg: item.procedureInfo })"
                          class="preview"
                        >
                          더보기
                        </button>
                        <!-- <input type="checkbox" name="preview" :disabled="item.procedureInfo.trim().length === 0" :id="`procedureInfo${idx}`" @click="clickLongText($event)" />
												<label :for="`procedureInfo${idx}`">더보기</label>

												<div class="openview">
													<span @click="clickLongTextClose(`procedureInfo${idx}`)"></span>
													<h2>시행/시술</h2>
													<div class="text">
														{{ item.procedureInfo }}
													</div>
												</div> -->
                      </div>
                    </td>
                    <td>{{ item.emplNm }}</td>
                    <td>{{ item.procedureNm }}</td>
                    <td>{{ item.rsrvCancelCd }}</td>
                    <td class="preview preview-rsrvCancelRmk">
                      <div v-if="item.rsrvCancelRmk.trim().length > 0">
                        <button
                          @click="clickLongText({ title: '부도메모', msg: item.rsrvCancelRmk })"
                          class="preview"
                        >
                          더보기
                        </button>
                      </div>
                      <!-- <input type="checkbox" name="preview" :disabled="item.rsrvCancelRmk.trim().length === 0" :id="`rsrvCancelRmk${idx}`" @click="clickLongText($event)" />
											<label :for="`rsrvCancelRmk${idx}`">보기</label>

											<div class="openview">
												<span @click="clickLongTextClose(`rsrvCancelRmk${idx}`)"></span>
												<h2>부도메모</h2>
												<div class="text">
													{{ item.rsrvCancelRmk }}
												</div>
											</div> -->
                    </td>
                    <td></td>
                  </template>
                </tr>
              </template>
              <template v-else>
                <tr class="background-transparent">
                  <td colspan="11" class="nodata">예약 내역이 없습니다</td>
                </tr>
              </template>
            </tbody>
          </table>

          <div v-show="forPreviewMargin.viewFlag" :style="{ height: forPreviewMargin.height }"></div>

          <template v-if="reserveInfo.length > 0">
            <div class="pl20 pr20">
              <template v-if="reserveInfo.length > reserveCnt">
                <a @click="tabListAdd('reserveCnt')" class="more">더보기</a>
              </template>
              <template v-else-if="reserveInfo.length <= reserveCnt && reserveInfo.length > 5">
                <a @click="tabListReflesh('reserveCnt')" class="more refresh">새로고침<i></i></a>
              </template>
              <!-- TODO 더보기가 아닌 새로고침이 나오도록 할 때 아래 example ★ refresh 클래스만 추가되고, 새로고침 문구 변경되고 -->
            </div>
          </template>
          <!-- 
				<div class="pl10 pr10 pb10">
					<a @click="tabListAdd('reserveCnt')" class="more">더보기</a>
				</div> -->
        </div>

        <div class="header mt30" id="tab3">
          <h2>
            <span>상담정보</span>
            <template v-if="tabFlag3 === true">
              <a @click="tabCollapse('3')" class="fold">목록 접기<i></i></a>
            </template>
            <template v-else>
              <a @click="tabCollapse('3')" class="fold expand">목록 펼치기<i></i></a>
            </template>
          </h2>
        </div>

        <div class="list-tbl-wrap">
          <table class="list-tbl mt30" v-if="tabFlag3 === true">
            <colgroup>
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
            </colgroup>
            <thead>
              <tr>
                <th>상담일자</th>
                <th>증상</th>
                <th>상담항목</th>
                <th>담당자</th>
                <th>진료분야</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="consultInfo.length > 0">
                <tr v-for="(item, idx) in consultInfo" :key="idx">
                  <template v-if="idx < consultCnt">
                    <td>
                      {{ item.ordYmd }}
                    </td>
                    <td class="text-left">{{ item.memo }}</td>
                    <td>{{ item.procedureRsrv }}</td>
                    <td>{{ item.doctEmplNm }}</td>
                    <td>{{ item.procedureNm }}</td>
                  </template>
                </tr>
              </template>
              <template v-else>
                <tr class="background-transparent">
                  <td colspan="5" class="nodata">상담 내역이 없습니다</td>
                </tr>
              </template>
            </tbody>
          </table>
          <template v-if="consultInfo.length > 0">
            <div class="pl20 pr20">
              <template v-if="consultInfo.length > consultCnt">
                <a @click="tabListAdd('consultCnt')" class="more">더보기</a>
              </template>
              <template v-else-if="consultInfo.length <= consultCnt && consultInfo.length > 5">
                <a @click="tabListReflesh('consultCnt')" class="more refresh">새로고침<i></i></a>
              </template>
            </div>
          </template>
        </div>

        <div class="header mt30" id="tab4">
          <h2>
            <span>시술정보</span>
            <template v-if="tabFlag4 === true">
              <a @click="tabCollapse('4')" class="fold">목록 접기<i></i></a>
            </template>
            <template v-else>
              <a @click="tabCollapse('4')" class="fold expand">목록 펼치기<i></i></a>
            </template>
          </h2>
        </div>

        <div class="list-tbl-wrap">
          <table class="list-tbl mt30" v-if="tabFlag4 === true">
            <colgroup>
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
            </colgroup>
            <thead>
              <tr>
                <th>시술일자</th>
                <th>증상</th>
                <th>시술항목</th>
                <th>담당자</th>
                <th>진료분야</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="procedureInfo.length > 0">
                <tr v-for="(item, idx) in procedureInfo" :key="idx">
                  <template v-if="idx < procedureCnt">
                    <td>{{ item.ordYmd }}</td>
                    <td class="text-left">{{ item.memo }}</td>
                    <td>{{ item.procedureRsrv }}</td>
                    <td>{{ item.doctEmplNm }}</td>
                    <td>{{ item.procedureNm }}</td>
                  </template>
                </tr>
              </template>
              <template v-else>
                <tr class="background-transparent">
                  <td colspan="5" class="nodata">시술 내역이 없습니다</td>
                </tr>
              </template>
            </tbody>
          </table>

          <template v-if="tabFlag4 === true && procedureInfo.length > 0">
            <div class="pl20 pr20">
              <template v-if="procedureInfo.length > procedureCnt">
                <a @click="tabListAdd('procedureCnt')" class="more">더보기</a>
              </template>
              <template v-else-if="procedureInfo.length <= procedureCnt && procedureInfo.length > 5">
                <a @click="tabListReflesh('procedureCnt')" class="more refresh">새로고침<i></i></a>
              </template>
              <!-- TODO 더보기가 아닌 새로고침이 나오도록 할 때 아래 example ★ refresh 클래스만 추가되고, 새로고침 문구 변경되고 -->
            </div>
          </template>
        </div>

        <div class="header mt30" id="tab5">
          <h2>
            <span>시술 특이사항</span>
            <template v-if="tabFlag5 === true">
              <a @click="tabCollapse('5')" class="fold">목록 접기<i></i></a>
            </template>
            <template v-else>
              <a @click="tabCollapse('5')" class="fold expand">목록 펼치기<i></i></a>
            </template>
          </h2>
        </div>

        <div class="list-tbl-wrap">
          <table class="list-tbl mt30" v-if="tabFlag5 === true">
            <colgroup>
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
            </colgroup>
            <thead>
              <tr>
                <th>일자</th>
                <th>진료분야</th>
                <th>시술코드</th>
                <th>시술</th>
                <th>시술회차</th>
                <th>시술 특이사항</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="procedureRemarkInfo.length > 0">
                <tr v-for="(item, idx) in procedureRemarkInfo" :key="idx">
                  <template v-if="idx < procedureRemarkCnt">
                    <td>{{ item.ordYmd }}</td>
                    <td>{{ item.nonProc }}</td>
                    <td>{{ item.ordCd }}</td>
                    <td>{{ item.userNm }}</td>
                    <td>{{ item.vol }}</td>
                    <td class="preview text-left">
                      <div v-if="item.memo.trim().length < 100">
                        {{ item.memo }}
                      </div>
                      <div v-else>
                        <span class="the">{{ item.memo }}</span>
                        <button
                          @click="clickLongText({ title: '시술 특이사항', msg: item.memo })"
                          class="preview"
                        >
                          더보기
                        </button>
                      </div>
                    </td>
                  </template>
                </tr>
              </template>
              <template v-else>
                <tr class="background-transparent">
                  <td colspan="6" class="nodata">시술 특이 내역이 없습니다</td>
                </tr>
              </template>
            </tbody>
          </table>
          <template v-if="tabFlag5 === true && procedureRemarkInfo.length > 0">
            <div class="pl20 pr20">
              <template v-if="procedureRemarkInfo.length > procedureRemarkCnt">
                <a @click="tabListAdd('procedureRemarkCnt')" class="more">더보기</a>
              </template>
              <template
                v-else-if="procedureRemarkInfo.length <= procedureRemarkCnt && procedureRemarkInfo.length > 5"
              >
                <a @click="tabListReflesh('procedureRemarkCnt')" class="more refresh">새로고침<i></i></a>
              </template>
              <!-- TODO 더보기가 아닌 새로고침이 나오도록 할 때 아래 example ★ refresh 클래스만 추가되고, 새로고침 문구 변경되고 -->
            </div>
          </template>
        </div>

        <div class="header mt30" id="tab6">
          <h2>
            <span>수납내역</span>

            <div class="pay-wrap">
              <div class="total">
                <span class="type">총 수납금액</span>
                <span class="pay">{{ this.$util.filters.currency(Number(paymentInfo.totAmt)) }}</span>
              </div>
              <div class="total">
                <span class="type pl50">잔여 미수금액</span>
                <span class="pay">{{ this.$util.filters.currency(Number(paymentInfo.ptntMisuAmt)) }}</span>
              </div>
            </div>

            <template v-if="tabFlag6 === true">
              <a @click="tabCollapse('6')" class="fold">목록 접기<i></i></a>
            </template>
            <template v-else>
              <a @click="tabCollapse('6')" class="fold expand">목록 펼치기<i></i></a>
            </template>
          </h2>
        </div>

        <div class="list-tbl-wrap" :class="{ 'list-tbl-wrap-last': !tabFlag6 }">
          <table class="list-tbl mt30" v-if="tabFlag6 === true">
            <colgroup>
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
              <col width="" />
            </colgroup>
            <thead>
              <tr>
                <th>수납일시</th>
                <th>발생일자</th>
                <th>수납방법</th>
                <th>유형</th>
                <th>계좌여부</th>
                <th>수납금액</th>
                <th>수납메모</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="paymentInfo.data != null && paymentInfo.data.length > 0">
                <tr v-for="(item, idx) in paymentInfo.data" :key="idx">
                  <template v-if="idx < paymentCnt">
                    <td>{{ item.payYmd }} <br />{{ item.payTime }}</td>
                    <td>{{ item.clinicYmd }}</td>
                    <td>{{ item.payGb }}</td>
                    <td>{{ item.recGb }}</td>
                    <td>{{ item.bankYn }}</td>
                    <td>{{ $util.filters.currency(Number(item.amt)) }}</td>
                    <td>{{ item.memo }}</td>
                  </template>
                </tr>
              </template>
              <template v-else>
                <tr class="background-transparent">
                  <td colspan="6" class="nodata">수납 내역이 없습니다</td>
                </tr>
              </template>
            </tbody>
          </table>
          <template v-if="tabFlag6 === true && paymentInfo.data != null">
            <template v-if="paymentInfo.data.length > 0 && paymentInfo.data.length > paymentCnt">
              <div class="pl20 pr20">
                <a @click="tabListAdd('paymentCnt')" class="more">더보기</a>
              </div>
            </template>
            <template v-else-if="paymentInfo.data.length <= paymentCnt && paymentInfo.data.length > 5">
              <div class="pl20 pr20">
                <a @click="tabListReflesh('paymentCnt')" class="more refresh">새로고침<i></i></a>
              </div>
            </template>
          </template>

          <!-- <template v-if="paymentInfo.length > 0">
						<div class="pl10 pr10 pb10">
							<template v-if="paymentInfo.length > paymentCnt">
								<a @click="tabListAdd('paymentCnt')" class="more">더보기</a>
							</template>
							<template v-else-if="paymentInfo.length <= paymentCnt && paymentInfo.length > 5">
								<a @click="tabListReflesh('paymentCnt')" class="more refresh">새로고침<i></i></a>
							</template>
						</div>
					</template> -->
          <!-- <template v-if="paymentInfo.data != null">
						<template v-if="paymentInfo.data.length > 0">
							<div class="pl10 pr10 pb10">
								<a @click="tabListAdd('paymentCnt')" class="more">더보기</a>
							</div>
						</template>
					</template> -->
          <div class="last-margin" v-show="tabFlag6 === true"></div>
        </div>
      </section>
      <!-- //컨텐츠-->

      <section class="view-quick-menu">
        <button @click="openPenChartMenu">
          <img :src="require('@/assets/img/common/quick-menu.png')" alt="" />
        </button>
      </section>

      <!-- 환자 클릭시 메뉴 정보 모달 -->
      <PenChartMenu :selectedInfo="$route.params.selectedInfo" />
      <LongTextPopup ref="longTextPopupRef" :propData="propData" />
    </div>
    <div v-show="renderFlag === 'N'"><loading-component></loading-component></div>
  </div>
</template>
<script>
import moment from 'moment';
import Loading from '../../components/loading/Loading.vue';
import PenChartMenu from '@/components/popup/PenChartMenu';
import LongTextPopup from '@/components/popup/LongTextPopup';
import { popOpenAndScrollNone } from '@/utils/UtilPopup';

export default {
  components: {
    'loading-component': Loading,
    PenChartMenu,
    LongTextPopup
  },
  data: () => ({
    opdMemoViewYn: '',
    ptntInfo: {
      ptntNm: '',
      phoneNo: '',
      tenNo: '',
      prsnNo: ''
    },
    reserveInfo: [],
    consultInfo: [],
    procedureInfo: [],
    procedureRemarkInfo: [],
    paymentInfo: [],
    optionStatus: [],
    viewIndex: 0,
    moreCnt: 5,
    reserveCnt: 0,
    consultCnt: 0,
    procedureCnt: 0,
    procedureRemarkCnt: 0,
    paymentCnt: 0,
    tabFlag3: true,
    tabFlag4: true,
    tabFlag5: true,
    tabFlag6: true,
    selectStatus: '',
    selectInsrDiv: '',
    renderFlag: 'N',

    forPreviewMargin: {
      viewFlag: false,
      height: '105px'
    },

    propData: { title: '', msg: '', id: 'longText' }
  }),
  async created() {
    //초기 기본적으로 보여지는 리스트 행수 세팅. 세팅값은 moreCnt
    this.reserveCnt = this.moreCnt;
    this.consultCnt = this.moreCnt;
    this.procedureCnt = this.moreCnt;
    this.procedureRemarkCnt = this.moreCnt;
    this.paymentCnt = this.moreCnt;
    let result = null;
    this.opdMemoViewYn = this.$store.state.settingInfo.opdMemoViewYn;

    //예약정보 - 상태값 콤보박스
    let url = `/crm/statusInfo`;
    if (this.$osType === 'web' || this.$osType === 'ios') {
      await this.$axios
        .get(url)
        .then((response) => {
          this.optionStatus = response.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      result = await this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
      this.optionStatus = result.data;
    }

    //환자 정보
    url = `/ptnt/ptntInfo/${this.$route.params.ptntNo}`;
    if (this.$osType === 'web' || this.$osType === 'ios') {
      await this.$axios
        .get(url)
        .then((response) => {
          this.ptntInfo = response.data.data;
          this.ptntInfo.phoneNo = this.$util.convPhoneNoHypen(this.ptntInfo.phoneNo);
          this.ptntInfo.telNo = this.$util.convPhoneNoHypen(this.ptntInfo.telNo);
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      result = await this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
      this.ptntInfo = result.data;
      this.ptntInfo.phoneNo = this.$util.convPhoneNoHypen(this.ptntInfo.phoneNo);
      this.ptntInfo.telNo = this.$util.convPhoneNoHypen(this.ptntInfo.telNo);
    }

    //예약 정보
    url = `/crm/reserveInfo/${this.$route.params.ptntNo}?insrDiv=${this.selectInsrDiv}&status=${this.selectStatus}`;
    if (this.$osType === 'web' || this.$osType === 'ios') {
      await this.$axios
        .get(url)
        .then((response) => {
          this.closeAllLongText(); // 팝업 삭제

          this.reserveInfo = response.data.data;
          if (this.reserveInfo == null) {
            this.reserveInfo = [];
          } else {
            this.reserveInfo.forEach((e) => {
              e.rsrvYmd = this.$util.convYmd2(e.rsrvYmd, '.');
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      result = await this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
      this.closeAllLongText(); // 팝업 삭제

      this.reserveInfo = result.data;
      if (this.reserveInfo == null) {
        this.reserveInfo = [];
      } else {
        this.reserveInfo.forEach((e) => {
          e.rsrvYmd = this.$util.convYmd2(e.rsrvYmd, '.');
        });
      }
    }

    //상담 정보
    url = `/crm/consultInfo/${this.$route.params.ptntNo}`;
    if (this.$osType === 'web' || this.$osType === 'ios') {
      await this.$axios
        .get(url)
        .then((response) => {
          this.consultInfo = response.data.data;
          if (this.consultInfo == null) {
            this.consultInfo = [];
          } else {
            this.consultInfo.forEach((e) => {
              e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      result = await this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
      this.consultInfo = result.data;
      if (this.consultInfo == null) {
        this.consultInfo = [];
      } else {
        this.consultInfo.forEach((e) => {
          e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
        });
      }
    }

    //시술 정보
    url = `/crm/procedureInfo/${this.$route.params.ptntNo}`;
    if (this.$osType === 'web' || this.$osType === 'ios') {
      await this.$axios
        .get(url)
        .then((response) => {
          this.procedureInfo = response.data.data;
          if (this.procedureInfo == null) {
            this.procedureInfo = [];
          } else {
            this.procedureInfo.forEach((e) => {
              e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      result = await this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
      this.procedureInfo = result.data;
      if (this.procedureInfo == null) {
        this.procedureInfo = [];
      } else {
        this.procedureInfo.forEach((e) => {
          e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
        });
      }
    }

    //시술 특이사항
    url = `/crm/procedureRemarkInfo/${this.$route.params.ptntNo}`;
    if (this.$osType === 'web' || this.$osType === 'ios') {
      await this.$axios
        .get(url)
        .then((response) => {
          this.procedureRemarkInfo = response.data.data;
          if (this.procedureRemarkInfo == null) {
            this.procedureRemarkInfo = [];
          } else {
            this.procedureRemarkInfo.forEach((e) => {
              e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      result = await this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
      this.procedureRemarkInfo = result.data;
      if (this.procedureRemarkInfo == null) {
        this.procedureRemarkInfo = [];
      } else {
        this.procedureRemarkInfo.forEach((e) => {
          e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
        });
      }
    }

    //수납정보
    url = `/crm/paymentInfo/${this.$route.params.ptntNo}`;
    if (this.$osType === 'web' || this.$osType === 'ios') {
      await this.$axios
        .get(url)
        .then((response) => {
          this.paymentInfo = response.data;
          if (this.paymentInfo.data == null) {
            this.paymentInfo.data = [];
          } else {
            this.paymentInfo.data.forEach((e) => {
              e.payYmd = this.$util.convYmd2(e.payYmd, '.');
              e.payTime = e.payTime.substr(0, 2) + ':' + e.payTime.substr(2, 2);
              if (e.clinicYmd.length == 8) {
                e.clinicYmd = this.$util.convYmd2(e.clinicYmd, '.');
              }
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      result = await this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
      this.paymentInfo = result;
      if (this.paymentInfo.data == null) {
        this.paymentInfo.data = [];
      } else {
        this.paymentInfo.data.forEach((e) => {
          e.payYmd = this.$util.convYmd2(e.payYmd, '.');
          e.payTime = e.payTime.substr(0, 2) + ':' + e.payTime.substr(2, 2);
          if (e.clinicYmd.length == 8) {
            e.clinicYmd = this.$util.convYmd2(e.clinicYmd, '.');
          }
        });
      }
    }
    this.renderFlag = 'Y';
  },
  methods: {
    pageBefore() {
      this.$router
        .push({
          name: '대기리스트',
          params: {
            selectDept: this.$route.params.selectDept,
            searchKeyword: this.$route.params.searchKeyword,
            selectYYYY: this.$route.params.selectYYYY,
            selectDate: this.$route.params.selectDate,
            activeTab: this.$route.params.activeTab
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    //선택한 탭 항목으로 이동
    tabMove(seq) {
      const offset = document.querySelector('#tab' + seq).offsetTop;
      const topHeight = document.querySelector('.top-fixing').clientHeight + 21;
      window.scrollTo({ top: offset - topHeight, behavior: 'smooth' });

      //탭 선택시 리스트 항목 자동으로 펼처지게끔
      if (seq === '3') {
        this.tabFlag3 = true;
      } else if (seq === '4') {
        this.tabFlag4 = true;
      } else if (seq === '5') {
        this.tabFlag5 = true;
      }

      // active
      const topMenu = document.querySelectorAll('.sub-menu a');

      topMenu.forEach((el) => {
        el.classList.remove('active');
      });

      topMenu[seq - 1].classList.add('active');
    },
    //접기
    tabCollapse(seq) {
      if (seq === '3') {
        this.tabFlag3 = !this.tabFlag3;
      } else if (seq === '4') {
        this.tabFlag4 = !this.tabFlag4;
      } else if (seq === '5') {
        this.tabFlag5 = !this.tabFlag5;
      } else if (seq === '6') {
        this.tabFlag6 = !this.tabFlag6;
      }
    },
    //더보기
    tabListAdd(str) {
      console.log('str=', str);
      if (str === 'procedureCnt') {
        //시술정보
        this.procedureCnt += this.moreCnt;
        console.log(`시술 총개수 = ${this.procedureInfo.length} 현재 행 개수 = ${this.procedureCnt}`);
      } else if (str === 'consultCnt') {
        //상담정보
        this.consultCnt += this.moreCnt;
        console.log(`상담정보 총개수 = ${this.consultInfo.length} 현재 행 개수 = ${this.consultCnt}`);
      } else if (str === 'procedureRemarkCnt') {
        //시술 특이사항
        this.procedureRemarkCnt += this.moreCnt;
        console.log(
          `시술특이사항 총개수 = ${this.procedureRemarkInfo.length} 현재 행 개수 = ${this.procedureRemarkCnt}`
        );
      } else if (str === 'paymentCnt') {
        this.paymentCnt += this.moreCnt;
        console.log(`수납내역 = ${this.paymentInfo.length} 현재 행 개수 = ${this.paymentCnt}`);
      } else if (str === 'reserveCnt') {
        //예약정보
        this.reserveCnt += this.moreCnt;
        console.log(`예약정보 = ${this.reserveInfo.length} 현재 행 개수 = ${this.reserveCnt}`);
      }
    },
    //새로고침
    tabListReflesh(str) {
      let url = '';
      //리플레쉬
      if (str === 'procedureCnt') {
        this.procedureCnt = 0;
        //시술 정보
        url = `/crm/procedureInfo/${this.$route.params.ptntNo}`;
        let result = null;
        if (this.$osType === 'web' || this.$osType === 'ios') {
          this.$axios
            .get(url)
            .then((response) => {
              this.procedureInfo = response.data.data;
              if (this.procedureInfo == null) {
                this.procedureInfo = [];
              } else {
                this.procedureInfo.forEach((e) => {
                  e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
                });
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
          this.procedureInfo = result.data;
          if (this.procedureInfo == null) {
            this.procedureInfo = [];
          } else {
            this.procedureInfo.forEach((e) => {
              e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
            });
          }
        }
        this.tabListAdd('procedureCnt');
        this.tabMove('4');
      } else if (str === 'reserveCnt') {
        //예약 정보
        this.reserveCnt = 0;
        let result = null;
        url = `/crm/reserveInfo/${this.$route.params.ptntNo}?insrDiv=${this.selectInsrDiv}&status=${this.selectStatus}`;
        if (this.$osType === 'web' || this.$osType === 'ios') {
          this.$axios
            .get(url)
            .then((response) => {
              this.closeAllLongText(); // 팝업 삭제

              this.reserveInfo = response.data.data;
              if (this.reserveInfo == null) {
                this.reserveInfo = [];
              } else {
                this.reserveInfo.forEach((e) => {
                  e.rsrvYmd = this.$util.convYmd2(e.rsrvYmd, '.');
                });
              }

              console.log('예약정보', this.reserveInfo);
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
          this.closeAllLongText(); // 팝업 삭제

          this.reserveInfo = result.data;
          if (this.reserveInfo == null) {
            this.reserveInfo = [];
          } else {
            this.reserveInfo.forEach((e) => {
              e.rsrvYmd = this.$util.convYmd2(e.rsrvYmd, '.');
            });
          }
        }
        this.tabListAdd('reserveCnt');
        this.tabMove('2');
      } else if (str === 'consultCnt') {
        //상담 정보
        this.consultCnt = 0;
        let result = null;
        url = `/crm/consultInfo/${this.$route.params.ptntNo}`;
        if (this.$osType === 'web' || this.$osType === 'ios') {
          this.$axios
            .get(url)
            .then((response) => {
              this.consultInfo = response.data.data;
              if (this.consultInfo == null) {
                this.consultInfo = [];
              } else {
                this.consultInfo.forEach((e) => {
                  e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
                });
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
          this.consultInfo = result.data;
          if (this.consultInfo == null) {
            this.consultInfo = [];
          } else {
            this.consultInfo.forEach((e) => {
              e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
            });
          }
        }

        this.tabListAdd('consultCnt');
        this.tabMove('3');
      } else if (str === 'procedureRemarkCnt') {
        //시술 특이사항
        this.procedureRemarkCnt = 0;
        let result = null;

        url = `/crm/procedureRemarkInfo/${this.$route.params.ptntNo}`;
        if (this.$osType === 'web' || this.$osType === 'ios') {
          this.$axios
            .get(url)
            .then((response) => {
              this.procedureRemarkInfo = response.data.data;
              console.log('시술특이사항', this.procedureRemarkInfo);

              if (this.procedureRemarkInfo == null) {
                this.procedureRemarkInfo = [];
              } else {
                this.procedureRemarkInfo.forEach((e) => {
                  e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
                });
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
          this.procedureRemarkInfo = result.data;
          console.log('시술특이사항', this.procedureRemarkInfo);

          if (this.procedureRemarkInfo == null) {
            this.procedureRemarkInfo = [];
          } else {
            this.procedureRemarkInfo.forEach((e) => {
              e.ordYmd = this.$util.convYmd2(e.ordYmd, '.');
            });
          }
        }

        this.tabListAdd('procedureRemarkCnt');
        this.tabMove('5');
      } else if (str === 'paymentCnt') {
        //수납정보
        this.paymentCnt = 0;
        let result = null;
        if (this.$osType === 'web' || this.$osType === 'ios') {
          url = `/crm/paymentInfo/${this.$route.params.ptntNo}`;
          this.$axios
            .get(url)
            .then((response) => {
              this.paymentInfo = response.data;
              if (this.paymentInfo.data == null) {
                this.paymentInfo.data = [];
              } else {
                this.paymentInfo.data.forEach((e) => {
                  e.payYmd = this.$util.convYmd2(e.payYmd, '.');
                  e.payTime = e.payTime.substr(0, 2) + ':' + e.payTime.substr(2, 2);
                  if (e.clinicYmd.length == 8) {
                    e.clinicYmd = this.$util.convYmd2(e.clinicYmd, '.');
                  }
                });
              }
              console.log('수납정보', this.paymentInfo);
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
          this.paymentInfo = result;
          if (this.paymentInfo.data == null) {
            this.paymentInfo.data = [];
          } else {
            this.paymentInfo.data.forEach((e) => {
              e.payYmd = this.$util.convYmd2(e.payYmd, '.');
              e.payTime = e.payTime.substr(0, 2) + ':' + e.payTime.substr(2, 2);
              if (e.clinicYmd.length == 8) {
                e.clinicYmd = this.$util.convYmd2(e.clinicYmd, '.');
              }
            });
          }
          console.log('수납정보', this.paymentInfo);
        }

        this.tabListAdd('paymentCnt');
        this.tabMove('6');
      }
    },
    //급여차트 보기 이동 ( CRM환자는 급여차트보기로 이동 가능)
    movePatientChartInfo() {
      this.$router
        .push({
          name: '환자차트정보',
          params: {
            ptntNo: this.$route.params.ptntNo,
            receptNo: this.$route.params.receptNo,
            date: moment(this.date).format('YYYYMMDD'),
            btnViewYn: 'Y',
            ptntNm: this.ptntInfo.ptntNm,
            selectedInfo: this.$route.params.selectedInfo
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    changeStatus() {
      console.log('상태변경', this.selectStatus);
      //예약 정보
      let url = `/crm/reserveInfo/${this.$route.params.ptntNo}?insrDiv=${this.selectInsrDiv}&status=${this.selectStatus}`;
      let result = null;
      if (this.$osType === 'web' || this.$osType === 'ios') {
        this.$axios
          .get(url)
          .then((response) => {
            this.closeAllLongText(); // 팝업 삭제

            this.reserveInfo = response.data.data;
            if (this.reserveInfo === null) {
              this.reserveInfo = [];
            } else {
              this.reserveInfo.forEach((e) => {
                e.rsrvYmd = this.$util.convYmd2(e.rsrvYmd, '.');
              });
            }
            console.log('예약정보', this.reserveInfo);
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
        this.closeAllLongText(); // 팝업 삭제

        this.reserveInfo = result.data;
        if (this.reserveInfo === null) {
          this.reserveInfo = [];
        } else {
          this.reserveInfo.forEach((e) => {
            e.rsrvYmd = this.$util.convYmd2(e.rsrvYmd, '.');
          });
        }
        console.log('예약정보', this.reserveInfo);
      }
    },

    procColor(str) {
      let color = '';
      if (str === '접수' || str === '접수취소') {
        color = 'receipt';
      } else if (str === '접수대기') {
        color = 'wait';
      } else if (str === '진료중') {
        color = 'diagnosis';
      } else if (str === '진료보류' || str === '접수대기') {
        color = 'hold';
      } else if (str === '진료완료') {
        color = 'diagnosis';
      } else if (str === '예약' || str === '예약취소') {
        color = 'reserve';
      } else if (str === '보류') {
        color = 'compensation';
      } else if (str === '수납완료') {
        color = 'storecom';
      } else if (str === '입원') {
        color = 'admission';
      } else if (str === '퇴원') {
        color = 'discharge';
      }
      return color;
    },

    openPenChartMenu() {
      // 팝업 띄우기
      popOpenAndScrollNone('#dimPenChartMenu .dim-popup-mark', '#dimPenChartMenu .dim-popup-content');
    },

    // 보기 클릭
    clickLongText(obj) {
      this.propData.title = obj.title;
      this.propData.msg = obj.msg;
      this.$refs.longTextPopupRef.open();
      // const target = e.target;
      // const chkDoms = document.querySelectorAll(`input[name=${target.name}]`);
      // const baseChecked = target.checked;

      // chkDoms.forEach(element => {
      // 	element.checked = false;
      // });

      // if (baseChecked) {
      // 	target.checked = true;

      // 	// 팝업이 더 클 경우 팝업 나올 공백 주기
      // 	const chkParentDom = target.closest('.list-tbl');
      // 	const openViewDom = target.closest('td').querySelector('.openview');

      // 	if (openViewDom.offsetTop + openViewDom.clientHeight > chkParentDom.clientHeight) {
      // 		this.forPreviewMargin.height = openViewDom.offsetTop + openViewDom.clientHeight - chkParentDom.clientHeight + 30 + 'px';
      // 		this.forPreviewMargin.viewFlag = true;
      // 	}
      // } else {
      // 	this.forPreviewMargin.viewFlag = false;
      // }
    },
    // clickLongTextClose(id) {
    // 	const popDom = document.querySelector(`#${id}`);
    // 	popDom.checked = false;

    // 	this.forPreviewMargin.viewFlag = false;
    // },
    closeAllLongText() {
      const chkDoms = document.querySelectorAll(`input[name=preview]`);
      chkDoms.forEach((element) => {
        element.checked = false;
      });

      this.forPreviewMargin.viewFlag = false;
    },
    clickLongText2(obj) {
      this.propData.title = obj.title;
      this.propData.msg = obj.msg;

      this.$refs.longTextPopupRef.open();
    }
  }
};
</script>

<style scoped src="../../assets/css/page/patientChartInfoCrm.css"></style>
